<template lang="html">
  <div class="rect">
    <div class="d-flex flex-row justify-content-between">
      <h1 style="text-align: left">Fab User Journey</h1>
      <ItemToggle :items="[{key: 'unique', title: 'Unique'}, {key: 'recurring', title: 'Recurring'}]"
                  :selected="selectedStats"
                  @toggle="toggleStats"
                  :has-border="true" />
    </div>
    <div class="content-wrapper">
      <div class="row flex-row">
        <template v-for="(option, index) in items">
          <div class="circle-wrapper">
            <div class="circle-inner">
              <p>{{ (data[selectedStats][option.key] || 0) | addK }}</p>
              <h3>{{ option.hasPrefix ? `${selectedStats} ` : '' }}{{ option.title }}</h3>
            </div>
          </div>
          <i v-if="index < items.length - 1" class="icon icon-arrow"></i>
        </template>
        <div class="circle-wrapper final">
          <div class="circle-inner">
            <p>{{ (data[selectedStats]['uniqueOffers'] || 0) | addK }}</p>
            <h3>unique offers</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { addK } from '../../filters/number.filters'
import { FabUserJourneyType } from '@/components/analytics/customerCustom/fab.types'
import ItemToggle from '@/components/helpers/ItemToggle.vue'

@Component({
  components: { ItemToggle },
  filters: {
    addK: addK
  }
})
export default class FabUserJourney extends Vue {
  @Prop({ type: Object, required: true }) data: FabUserJourneyType

  readonly items = [
    { title: `users`, key: 'users', hasPrefix: true },
    { title: 'sessions', key: 'sessions' },
    { title: 'offers shown', key: 'offersShown' },
    { title: 'offers clicked', key: 'offersClicked' }
  ]

  private selectedStats: 'unique' | 'recurring' = 'unique'

  toggleStats(value: 'unique' | 'recurring') {
    this.selectedStats = value
  }

}
</script>

<style scoped lang="scss">
@import '../analytics.style.scss';
@import '../../../assets/scss/setup/_colors.scss';

.rect {
  h1 {
    color: $main;
    font-size: 14px;
    font-weight: 600;
    line-height: 15px;
    text-transform: uppercase;
  }

  .row {
    padding: 0 14px;
    justify-content: space-between;
    align-items: center;
  }

  .circle-wrapper {
    width: 133px;
    height: 133px;
    background: linear-gradient(to bottom, #7C3BFF, #4A2399);
    border-radius: 50%;
    padding: 4px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    .circle-inner {
      width: 100%;
      height: 100%;
      background-color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    &.final {
      margin-left: auto;
      background: rgba(5, 21, 81, 0.41);

      .circle-inner {
        background-color: rgba(241, 243, 253, 1);
      }

      p {
        color: rgba(5, 21, 81, 0.6);
        font-weight: 700;
      }

      h3 {
        color: rgba(5, 21, 81, 1);
      }
    }
  }

  h3, p {
    margin: 0;
    text-align: center;

  }

  h3 {
    font-size: 12px;
    font-weight: 600;
    color: $main;
    line-height: 15px;
    text-transform: uppercase;
    width: 50%;
    height: 30px;
  }

  p {
    font-size: 26px;
    font-weight: 300;
    color: #000;
    line-height: 33px;
  }

  .icon-arrow {
    height: 16px;
    width: 46px;
    margin: 0 6px;
  }
}


</style>